"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStandardDescriptionContentType = exports.isGenerativeDescriptionContentType = exports.StandardDescriptionContentTypes = exports.GenerativeDescriptionContentTypes = void 0;
exports.GenerativeDescriptionContentTypes = ['datasource', 'workbook', 'table'];
exports.StandardDescriptionContentTypes = ['database', 'flow'];
function isGenerativeDescriptionContentType(contentType) {
    return exports.GenerativeDescriptionContentTypes.includes(contentType);
}
exports.isGenerativeDescriptionContentType = isGenerativeDescriptionContentType;
function isStandardDescriptionContentType(contentType) {
    return exports.StandardDescriptionContentTypes.includes(contentType);
}
exports.isStandardDescriptionContentType = isStandardDescriptionContentType;
//# sourceMappingURL=DescriptionTypes.js.map